import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class DeleteDevice extends Component {
  submitModal = () => {
    const { deleteDevice, modalData } = this.props;
    deleteDevice(modalData);
  };

  render() {
    const { toggleModal, t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader toggle={toggleModal}>
          {t("dashboard.deleteDevice")}
        </ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column align-items-center">
            <i
              className="fas fa-question-circle text-warning display-4"
              style={{ fontWeight: 900 }}
            ></i>
            <p className="text-warning">{t("dashboard.warning!")}</p>
            <p className="px-3 text-center">
              {t("dashboard.areYouSureYouWantToPermanentlyRemoveThisDevice?")}
              <br /> {t("dashboard.pleaseNoteThereAreCurrentlyActiveAlarms")}
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={this.submitModal}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDevice: (data) => dispatch(actions.deleteDevice(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("translations")(DeleteDevice));
